<template>
  <component
    :is="as"
    :type="type"
    :class="['icon-button', { hidden }]"
    :disabled="disabled || loading"
    v-bind="$attrs"
    v-on="$listeners"
    v-tooltip="{ content: tooltip, delay: { show: 1500, hide: 100 }, placement: 'bottom' }"
  >
    <icon
      class="icon"
      :name="icon"
      :style="{ 'font-size': `${size}px` }"
    />

    <span v-if="alert" class="alert" />

    <span v-show="loading" class="spinner-container">
      <span class="spinner" />
    </span>
  </component>
</template>

<script>
import Icon from './Icon';

export default {
  components: {
    Icon,
  },

  props: {
    as: {
      type: String,
      default: 'button',
    },
    type: {
      type: String,
      default: 'button',
    },
    icon: String,
    hidden: Boolean,
    loading: Boolean,
    disabled: Boolean,
    tooltip: String,
    alert: Boolean,
    size: {
      type: String,
      default: '24',
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../scss/variables.scss';

.icon-button {
  border: none;
  outline: none;
  padding: 0;
  display: inline-flex;
  position: relative;
  background: transparent;
  text-decoration: none !important;

  .icon {
    position: relative;
    color: var(--theme-icon-button-color);
  }

  &:before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 125%;
    height: 125%;
    background-color: var(--theme-icon-hover);
    border-radius: 50%;
    transform: translate(-50%, -50%) scale(0);
    @include transition(transform, background-color);
  }

  &:not(:disabled) {
    cursor: pointer;

    &:hover,
    &:focus {
      &:before {
        transform: translate(-50%, -50%) scale(1);
      }
    }
  }

  &:active {
    &:before {
      background-color: rgba(0, 0, 0, 0.2);
    }
  }

  &:disabled {
    opacity: 0.5;
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.alert {
  position: absolute;
  top: 0;
  right: 3px;
  height: 8px;
  width: 8px;
  border-radius: 50%;
  background-color: $color-red-1;
  z-index: 1;
}

.spinner-container {
  width: calc(125% + 4px);
  height: calc(125% + 4px);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.spinner {
  display: block;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  transform: translateZ(0);
  animation: spin 1s infinite linear;
  border-top: 2px solid $color-green-1;
  border-right: 2px solid $color-green-1;
  border-bottom: 2px solid $color-green-1;
  border-left: 2px solid transparent;
}
</style>
